export enum EntityNames {
  Dashboard = 'Z7aW',
  Dashboards = 'pTvK',
  InventoryOrder = 'uesp',
  InventoryOrders = 'pOmD',
  InventoryItem = 'sED9',
  InventoryItems = 'mvYj',
  Site = '+nlV',
  Sites = 'nXaQ',
  Transfer = '3ei+',
  Transfers = 'xBfL',
  Event = 'Th9J',
  Events = 'jRT2',
  StandWorksheet = '8wHa',
  StandWorksheets = 'SUnK',
  RecipeVenue = 'wpiB',
  RecipeVenues = 'EP0p',
  Product = '+574',
  Products = 'TtyL',
  ProductPrice = 'fgHe',
  ProductPrices = 'nCkb',
  InventoryCount = '7Etv',
  InventoryCounts = 'u6jj',
  Tag = 'FQOR',
  Tags = 'EzEn',
  EventType = 'nIW3',
  EventTypes = 'w7rR',
  Cart = 'bS1Z',
  Carts = 'vNSl',
  TransferGroup = 'N9YN',
  TransferGroups = 'jFll',
  TransferGroupTemplate = 'Xlc4',
  TransferGroupTemplates = 'u+HX',
  FilteredTransfer = 'D1/g',
  FilteredTransfers = '0PwV',
  TransferRequest = 'VglJ',
  TransferRequests = '5atj',
  IncompleteTransfer = 'FxzS',
  IncompleteTransfers = 'CSPc',
  HistoricalTransferQuantity = 'ZwqB',
  HistoricalTransferQuantities = '8ipC',
  CurrencyScheme = 'nYUv',
  CurrencySchemes = '4at5',
  SaleDepletion = '6AD1',
  SaleDepletions = '4RTc',
  AuditTrail = '1StA',
  AuditTrails = 'xyU2',
  FilteredOrder = 'YhDf',
  FilteredOrders = 'G4Qt',
  TransferDestination = 'KL4s',
  TransferDestinations = 'gXT0',
  VENDOR = '7j5Q',
  Vendor = '+KqC',
  Warehouse = 'KmJc',
  InventoryValue = 'Tx1t',
  NonWarehouse = 'X4wj',
  DepartmentCode = 'LS4k',
  SiteSingularAndPlural = 'zDaR',
  InventoryCountSheet = '2Ta9',
  siteSingularAndPlural = 'GhJx',
  CommissionRate = 'mpLd',
  CommissionRates = 'nHbY',
  Hawker = 'GfRH',
  Hawkers = 'OUG7',
  HawkerProfile = 'O8gv',
  HawkerProfiles = 'xJ/H',
  ReportingCategory = 'Uz7C',
  ReportingCategories = 'rMSS',
  ProductSingularAndPlural = 'Aemo',
  StandWorksheetItem = 'k1fv',
  StandWorksheetItems = 'BTVp',
  HawkerLoad = '1HeV',
  HawkerLoads = 'eF88',
  HawkerCommissaryAssignment = 'EO2t',
  HawkerCommissaryAssignments = 'f0sk',
  HawkerSession = 'PaxN',
  HawkerSessions = 'UI0M',
  HawkerCommissaryAssignmentHistory = 'X6pU',
  HawkerCommissaryAssignmentHistories = 'AQov',
}
